import script from "./MemberJoinSuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberJoinSuccessView.vue?vue&type=script&setup=true&lang=js"

import "./MemberJoinSuccessView.vue?vue&type=style&index=0&id=2a23dd9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a23dd9e"]])

export default __exports__